import { formatDate, formatTime } from "@helmr/ui";
import { addDays, today as localDate } from "../../lib/dates";
import { inbox } from "./strings";

/** List time: clock today, "Yesterday", otherwise a short date. Business timezone, never the device's. */
export function listTime(at: number, now: number, timeZone: string, locale: string): string {
  const day = localDate(at, timeZone);
  const today = localDate(now, timeZone);
  if (day === today) return formatTime(at, timeZone);
  if (day === addDays(today, -1)) return inbox.thread.yesterday;
  return formatDate(day, locale, "short");
}

/** Day separator text. */
export function dayLabel(day: string, today: string, locale: string): string {
  if (day === today) return inbox.thread.today;
  if (day === addDays(today, -1)) return inbox.thread.yesterday;
  return formatDate(day, locale, "weekday");
}

export const firstName = (name: string | null | undefined) => (name ?? "").trim().split(/\s+/)[0] ?? "";
